<template>
  <v-icon
    small
    class="mr-2"
    color="blue"
    @click="showDetails"
    style="padding: 10%"
  >
    mdi-plus-circle
  </v-icon>
</template>

<script>
export default {
  name: 'CollatMoreDetails',
  methods: {
    showDetails() {
      this.params.context.componentParent.showCollatDetails(this.params.data);
    }
  }
};
</script>

<style scoped>

</style>
